module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('div', {
    staticClass: "title-acknowPage"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781250015945_toc01#toctitle1",
      "id": "title1"
    }
  }, [_c('span', [_vm._v("Thanks to")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-c"
  }, [_c('span', [_vm._v("Lisa Moylett, Suzie Doore, Francine Toon, Imogen Olsen, Alice Laurent, Jessica Hische and Katie Davison.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-c"
  }, [_c('span', [_vm._v("Bronwen Salter-Murison, for designing and maintaining the Dandy Gilver website.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-c"
  }, [_c('span', [_vm._v("Sharron McColl, Dorothy Hall and Jeanette MacMillan of the Local History Dept in the Carnegie Library, Dunfermline and library user James Fraser, for information about old Dunfermline.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-c"
  }, [_c('span', [_vm._v("Louise Kelly, for unflagging support and unsettling craftwork.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-c"
  }, [_c('span', [_vm._v("And Neil.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-c"
  }, [_c('span', [_vm._v("One of the differences between academia and fiction-writing that I cherish most is no longer having to record and then cite all my sources, but I must mention the insanely detailed and unexpectedly riveting Lee E Gray, (2002), "), _c('em', {
    staticClass: "i"
  }, [_vm._v("From Ascending Rooms to Express Elevators: A History of the Passenger Elevator in the Nineteenth Century")]), _vm._v(" (Mobile, Ala: Elevator World, Inc.), without which Aitkens’ lift would still be a mystery to me.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd328f98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781250015945_ack01.vue
// module id = 69
// module chunks = 0